module.exports = __webpack_public_path__ + "img/38124-101.63b4b494.jpg";